<template>
  <div class="page add-friend-page">
    <h1>添加滋仙草企业顾问</h1>
    <template v-if="contact.active">
      <p>正在为你打开企业微信，如果没有自动跳转，点下面的按钮也一样。</p>
      <ContactFriend placement="hero" />
    </template>
    <p v-else>联系入口暂时不可用，请稍后再试，或先看看<a href="/products.html">我们的产品</a>。</p>
    <p><a href="/">返回滋仙草官网</a></p>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import rawContactConfig from '@/config/contact.json'
import { validateContactConfig } from '@/contact/contactPolicy.mjs'
import { scheduleContactAutoNavigation } from '@/contact/contactAutoNav.mjs'

/**
 * @returns {Storage | null}
 */
function readSessionStorage() {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

// 只有这个专用获客页会在首次打开时自动进入企业微信；官网内容页不自动跳转。
export default {
  name: 'AddFriendPage',
  components: {
    ContactFriend
  },
  data() {
    return {
      contact: validateContactConfig(rawContactConfig)
    }
  },
  mounted() {
    this.cancelAutoNavigation = scheduleContactAutoNavigation(rawContactConfig, {
      storage: readSessionStorage(),
      navigate: (url) => window.location.assign(url)
    })
  },
  beforeUnmount() {
    if (this.cancelAutoNavigation) {
      this.cancelAutoNavigation()
      this.cancelAutoNavigation = null
    }
  }
}
</script>

<style scoped>
.page {
  max-width: 560px;
  margin: 0 auto;
  padding: 24px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.4em;
  margin: 0 0 8px;
}

p {
  color: #333;
  line-height: 1.7;
}

a {
  color: #6a1bb0;
}
</style>
